import { render, staticRenderFns } from "./RecoverySimulator.vue?vue&type=template&id=2c621175"
import script from "./RecoverySimulator.vue?vue&type=script&lang=js"
export * from "./RecoverySimulator.vue?vue&type=script&lang=js"
import style0 from "./RecoverySimulator.vue?vue&type=style&index=0&id=2c621175&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports